<template>
  <div class="card my-4 mx-4">
    <div class="card-header pb-0">
      <h6>Multimedia Edit</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="p-3">
        <Form
          as="form"
          @submit="onFormSubmit"
          class="form"
          :validation-schema="schema"
          v-slot="{ errors }"
          enctype="multipart/form-data"
          v-if="media"
        >
          <div class="form-group">
            <label for="exampleInputEmail1">Model</label>
            <Field
              name="model"
              as="select"
              class="form-control"
              v-model="media.modelId"
              :class="{ 'is-invalid': errors.model }"
            >
              <option value="" disabled>Select value</option>
              <option
                v-for="(model, index) in models"
                :key="index"
                :value="model.id"
              >
                {{ model.name }}
              </option>
            </Field>

            <div class="invalid-feedback">{{ errors.model }}</div>
          </div>

          <div class="form-group">
            <label for="exampleInputEmail1">Media Type</label>
            <Field
              name="typeOfMedia"
              as="select"
              class="form-control"
              v-model="media.typeOfMedia"
              :class="{ 'is-invalid': errors.typeOfMedia }"
            >
              <option value="" disabled>Select value</option>
              <option value="image">Image</option>
              <option value="video">Video</option>
            </Field>
            <div class="invalid-feedback">{{ errors.typeOfMedia }}</div>
          </div>

          <div class="form-group">
            <button
              @click.prevent="() => this.$refs.fileInput.click()"
              class="btn btn-outline-danger"
            >
            Image / Video Upload 
            </button>
            <input
              type="file"
              ref="fileInput"
              @change="onFileChange"
              accept="video/*,image/*"
              style="display: none"
            />
          </div>
          <Field name="image" v-slot="{ errors }">
            <div v-if="errors.length">{{ errors[0] }}</div>
          </Field>
          <div v-if="!imageData && media.typeOfMedia == 'video'">
            <h3>Preview:</h3>
            <video width="360" height="240" controls>
              <source :src="imageApi + media.media" type="video/mp4" />
            </video>
          </div>
          <div v-if="media && !imageData && media.typeOfMedia != 'video'">
            <h3>Preview:</h3>
            <img
              :src="imageApi + media.media"
              alt="Image Preview"
              height="200"
              width="230"
            />
          </div>
          <div v-if="imageData && media.typeOfMedia != 'video'">
            <h3>Preview:</h3>
            <img
              :src="imageData"
              alt="Image Preview"
              height="200"
              width="230"
            />
          </div>
          <div v-if="imageData && media.typeOfMedia == 'video'">
            <h3>Preview:</h3>
            <video width="360" height="240" controls>
              <source :src="imaageData" type="video/mp4" />
            </video>
          </div>
          <button type="submit" class="btn btn-danger my-2">Submit</button>
          <button
            type="button"
            @click="handleCancel"
            class="btn btn-outline-success my-2 cancel-btn"
          >
            Cancel
          </button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Form, useForm } from "vee-validate";
import * as yup from "yup";
import { mapGetters } from "vuex";
import imageApi from "../../api/imageapi";
export default {
  name: "Multimedia Edit",
  components: {
    Form,
    Field,
  },
  setup() {
    const { setFieldValue } = useForm();
    return { setFieldValue };
  },
  data() {
    return {
      imageApi: imageApi,
      fileMain: null,
      imageData: null,
      schema: yup.object().shape({
        typeOfMedia: yup
          .string()
          .trim()
          .required("Select Media Type is required"),
        model: yup.string().trim().required("Select Model is required"),
      }),
    };
  },
  computed: {
    ...mapGetters("models", ["models"]),
    ...mapGetters("multimedia", ["media", "isLoading"]),
    id() {
      return this.$route.params.id;
    },
  },
  created() {
    if (this.id) {
      this.$store.dispatch("models/fetchModels", null, {
        root: true,
      });
      this.fetchDetail();
    }
  },
  mounted() {},
  methods: {
    updateInput() {
      this.$store.dispatch("multimedia/updateInput");
    },
    onFormSubmit(values, actions) {
      const obj = {
        ...values,
        image: this.fileMain,
      };
      const id = this.id;
      let formData = new FormData();
      formData.append("media", this.$refs.fileInput.files[0]);
      formData.append("typeOfMedia", obj.typeOfMedia);
      formData.append("modelId", obj.model);

      this.$store
        .dispatch("multimedia/put", { id, data: formData })
        .then(res => {
          if (res == 200) {
            this.$swal({
              position: "center",
              icon: "success",
              title: "Media has been Updated",
              showConfirmButton: false,
              timer: 2000,
            });
            actions.resetForm();
            this.$router.push("/multimedia");
          }
        })
        .catch(error => {
          // Handle any errors
          console.error("Error updating model:", error);
          this.$swal(
            "Error!",
            "There was an issue updating the model.",
            "error"
          );
        });
    },
    handleCancel() {
      this.$router.push("/multimedia");
    },
    onFileChange(event) {
      const file = event.target.files[0];
      console.log(file);
      this.fileMain = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = e => {
          this.imageData = e.target.result;
        };

        reader.readAsDataURL(file);
        // this.setFieldValue("image", file);
      } else if (file && file.type.startsWith("video/")) {
        const reader = new FileReader();
        reader.onload = e => {
          this.imageData = e.target.result;
        };

        reader.readAsDataURL(file);
        // this.setFieldValue("image", file);
      } else {
        alert("Please select a valid image file.");
      }
    },
    fetchDetail() {
      try {
        this.$store.dispatch("multimedia/fetchMediaDetail", this.id);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
